const salesCategory = 'Salg og daglig bruk';

const salesCategoryDescription =
  'Opplæring for selgere i bruk av Pipeline, LinkedIn Outreach og Lead Import.';

export const defaultKnowledgeArticles = [
  {
    id: 'pipeline-bruk-og-funksjoner',
    category: salesCategory,
    categoryDescription: salesCategoryDescription,
    title: 'Pipeline – bruk og funksjoner',
    description:
      'Lær hvordan du bruker Pipeline til å holde oversikt over leads, avtaler og neste salgsaktivitet.',
    context: ['/pipeline', '/projects'],
    content:
      'Pipeline gir deg en samlet oversikt over salgsarbeidet. Hvert pipeline-kort representerer en lead eller deal som du følger opp fra første kontakt til møte, tilbud eller avslutning.',
    steps: [
      'Åpne Pipeline fra menyen og velg riktig visning. Du kan se arbeidet etter Firma eller Kontakt.',
      'Et pipeline-kort er en lead eller deal. Kortet viser blant annet navn, verdi, status, sannsynlighet og forventet dato.',
      'Bruk Prospekt når du har funnet en mulig kunde. Bruk Lead når du har en konkret salgsmulighet. Bruk Oppfølging/ring opp når neste steg er en telefon eller annen aktiv oppfølging. Bruk Booket møte når et møte er avtalt.',
      'Flytt kortet mellom stegene ved å dra kortet til riktig kolonne, eller bruk redigeringen på kortet.',
      'Klikk på et kort for å åpne detaljene. Bruk Full View når du vil se og redigere all informasjon samlet.',
      'Rediger navn, verdi, sannsynlighet, status og forventet dato når situasjonen endrer seg.',
      'Legg til et kort notat etter hver viktig kontakt. Skriv hva kunden sa og hva som skal skje videre.',
      'Opprett en aktivitet når du skal ringe, sende e-post, holde møte eller gjøre en annen konkret oppgave.',
      'Arkiver kortet når saken ikke lenger skal ligge aktivt i Pipeline. Arkiver bare når du har vurdert om saken skal følges opp senere.'
    ],
    tips: [
      'Bruk Firma-visning når du jobber med kontoer og Kontakt-visning når du følger opp bestemte personer.',
      'Åpne Full View før du gjør en større oppdatering, slik at du ser hele kundebildet.',
      'Etter en samtale bør du alltid oppdatere status, neste aktivitet og notat.'
    ],
    commonMistakes: [
      'La kortet bli stående i samme steg etter at kunden har svart.',
      'Sette høy sannsynlighet uten at det finnes en avtalt neste handling.',
      'Opprette en ny lead uten først å sjekke om selskapet eller kontakten allerede finnes.',
      'Skrive lange, uklare notater uten dato eller tydelig neste steg.'
    ],
    bestPractices: [
      'Hold Pipeline oppdatert samme dag som kontakten skjer.',
      'Bruk neste aktivitet som din huskeliste.',
      'Skriv korte notater med formatet: Hva skjedde – hva betyr det – hva skjer videre?',
      'Sett forventet dato realistisk og juster den når kundens tidsplan endrer seg.'
    ],
    summary:
      'Etter hver kontakt med kunde, oppdater status, neste aktivitet og notat.'
  },
  {
    id: 'linkedin-outreach-bruk-og-funksjoner',
    category: salesCategory,
    categoryDescription: salesCategoryDescription,
    title: 'LinkedIn Outreach – bruk og funksjoner',
    description:
      'Lær hvordan du finner, organiserer og følger opp prospekter fra LinkedIn på en trygg og manuell måte.',
    context: ['/outreach'],
    content:
      'LinkedIn Outreach hjelper deg med å organisere manuell research og oppfølging. Saleswork CRM hjelper deg med søk, tekstforslag og oppfølging, men du utfører LinkedIn-handlingen manuelt.',
    steps: [
      'Åpne LinkedIn Outreach og opprett et nytt LinkedIn-prospekt.',
      'Bruk personprospekt når du har funnet en bestemt person. Bruk research-prospect når du først undersøker et selskap eller en mulig kontakt.',
      'Importer LinkedIn-profiler når du har flere profiler du vil registrere samtidig.',
      'Åpne Prospect Inbox for å se nye prospekter og plassere dem i riktig steg.',
      'Flytt prospekter mellom stegene med drag & drop. Flytt dem etter hvor langt du har kommet i oppfølgingen.',
      'Åpne LinkedIn fra prospektet når du skal kontrollere profil eller gjøre en handling.',
      'Kopier LinkedIn-lenken eller foreslått tekst ved behov. Gå deretter til LinkedIn og utfør handlingen selv.',
      'Bruk Dagens Outreach som arbeidsliste for dagens kontakter og oppgaver.',
      'Marker oppgaven som utført etter at du har sendt forespørsel, melding eller gjort avtalt research.',
      'Konverter et relevant LinkedIn-prospekt til Pipeline når det finnes en reell salgsmulighet.',
      'Allerede i Pipeline betyr at personen eller selskapet allerede er koblet til en aktiv pipeline-sak. Kontroller denne saken før du oppretter noe nytt.'
    ],
    tips: [
      'Bruk Prospect Inbox til å rydde og prioritere før du starter dagens oppfølging.',
      'Åpne alltid profilen før du sender melding, slik at teksten blir relevant.',
      'Bruk korte, personlige meldinger med én tydelig grunn til kontakt.'
    ],
    commonMistakes: [
      'Forvente at CRM-et sender LinkedIn-meldinger automatisk.',
      'Opprette samme person flere ganger.',
      'Konvertere alle prospekter til Pipeline før det finnes en reell salgsmulighet.',
      'Markere en oppgave som utført før handlingen faktisk er gjort.'
    ],
    bestPractices: [
      'Saleswork CRM hjelper deg med søk, tekstforslag og oppfølging, men du utfører LinkedIn-handlingen manuelt.',
      'Sjekk alltid om prospektet allerede finnes i Pipeline.',
      'Registrer neste handling med én gang du er ferdig med dagens LinkedIn-oppgave.',
      'Hold research-prospekter adskilt fra personer du faktisk har kontaktet.'
    ],
    summary:
      'Bruk CRM-et til struktur og oppfølging, men gjør alltid LinkedIn-handlingen manuelt.'
  },
  {
    id: 'lead-import-brreg-bruk-og-funksjoner',
    category: salesCategory,
    categoryDescription: salesCategoryDescription,
    title: 'Lead Import / BRREG – bruk og funksjoner',
    description:
      'Lær hvordan du finner relevante selskaper, vasker resultatene og sender gode leads videre til CRM.',
    context: ['/lead-import', '/settings/brreg'],
    content:
      'Lead Import / BRREG brukes til å finne norske virksomheter som passer målgruppen din. Resultatene går først til staging, slik at du kan kontrollere, vaske og godkjenne dem før de brukes i CRM.',
    steps: [
      'Åpne Lead Import / BRREG og opprett en ny importjobb.',
      'Velg et tydelig segmentnavn som beskriver målgruppen, for eksempel “Regnskapsbyrå i Oslo”.',
      'Bruk NACE-kode for å finne riktig bransje. Bruk kommune og fylke for geografisk avgrensning.',
      'Start med smale filtre. Utvid søket senere dersom resultatet blir for lite.',
      'Se resultatene i staging. Staging betyr at leads er midlertidig lagret for kontroll før de sendes videre.',
      'Vask listen ved å kontrollere navn, organisasjonsnummer, bransje, sted og kontaktinformasjon.',
      'Se etter markeringen Finnes allerede i CRM. Det betyr at selskapet allerede finnes i CRM og bør kontrolleres før du oppretter en ny rad.',
      'Godkjenn bare leads som passer målgruppen og har tilstrekkelig kvalitet.',
      'Send godkjente leads videre til CRM/Pipeline når du er klar til å jobbe med dem.',
      'Bruk LinkedIn-søk fra BRREG-leadet for å finne relevant kontaktperson.',
      'Opprett research-prospect fra selskapet når du trenger mer informasjon før du kontakter noen.'
    ],
    tips: [
      'Importer ikke alt ukritisk. Bruk staging og vask for å unngå rot og duplikater.',
      'Bruk segmentnavn som gjør importjobben lett å finne igjen senere.',
      'Kontroller organisasjonsnummer før du godkjenner et selskap.',
      'Start med én kommune eller ett fylke når du tester et nytt segment.'
    ],
    commonMistakes: [
      'Importere for brede søk uten tydelig målgruppe.',
      'Sende alle staging-leads direkte til CRM uten vask.',
      'Ignorere Finnes allerede i CRM-markeringen.',
      'Opprette LinkedIn-prospekt før du har kontrollert at selskapet er relevant.'
    ],
    bestPractices: [
      'Bruk BRREG til å bygge en målrettet liste, ikke en generell katalog.',
      'Godkjenn i små puljer og kontroller kvaliteten underveis.',
      'Bruk organisasjonsnummer som viktigste kontroll mot duplikater.',
      'Koble alltid videre oppfølging til riktig selskap og kontakt.'
    ],
    summary:
      'Bruk gode filtre, vask i staging og godkjenn bare relevante leads før de sendes til CRM.'
  },
  {
    id: 'anbefalt-salgsflyt-fra-lead-til-oppfolging',
    category: salesCategory,
    categoryDescription: salesCategoryDescription,
    title: 'Anbefalt salgsflyt – fra importert lead til oppfølging',
    description:
      'En enkel arbeidsflyt for å gå fra målrettet selskapsliste til strukturert salgsoppfølging.',
    context: ['/lead-import', '/outreach', '/pipeline'],
    content:
      'En god salgsflyt gjør at du jobber systematisk og unngår at relevante leads blir glemt. Følg trinnene nedenfor som en praktisk standardprosess.',
    steps: [
      'Finn selskaper i Lead Import / BRREG.',
      'Vask og godkjenn relevante leads i staging.',
      'Sjekk om selskapet finnes fra før i CRM.',
      'Finn riktig kontaktperson på LinkedIn.',
      'Opprett et LinkedIn-prospekt.',
      'Følg opp manuelt i Dagens Outreach.',
      'Konverter relevant prospekt til Pipeline.',
      'Oppdater Pipeline etter hver kontakt.',
      'Book møte eller sett en konkret neste aktivitet.',
      'Hold Pipeline oppdatert til saken er vunnet, tapt eller arkivert.'
    ],
    tips: [
      'Jobb ferdig med ett lite segment før du starter mange nye importjobber.',
      'Gå fra selskap til kontaktperson før du går fra prospekt til aktiv salgsmulighet.',
      'Planlegg alltid neste handling før du avslutter arbeidsøkten.'
    ],
    commonMistakes: [
      'Hoppe over vask og kontroll av eksisterende CRM-data.',
      'Ha leads i flere moduler uten tydelig neste steg.',
      'La oppfølging ligge i egen hukommelse i stedet for som aktivitet.',
      'Flytte en sak til Pipeline uten å skrive hvorfor den er kvalifisert.'
    ],
    bestPractices: [
      'Bruk samme arbeidsflyt hver gang, slik at ingenting faller mellom modulene.',
      'Hold selskapsdata, kontaktdata, prospekt og Pipeline-kort oppdatert.',
      'Avslutt hver arbeidsdag med å kontrollere Dagens Outreach og kommende aktiviteter.'
    ],
    summary:
      'Finn målgruppen, vask data, finn riktig person, følg opp manuelt og hold Pipeline oppdatert.'
  }
];

export default defaultKnowledgeArticles;